// Neutral converter for the date-period form values. Lives in its own module so
// the read and write mappers can share it without importing each other
// (`fieldSettingsMapper` already imports `QueryFieldRow` from `fieldsMapper`, so
// the reverse direction would form a cycle).

import type { DatePeriodValues } from "../../../../shared/DatePeriodSection/types";
import type { QueryFieldFieldsFragment } from "~/graphql/supergraphTypes";

type RawDatePeriod = NonNullable<QueryFieldFieldsFragment["datePeriod"]>;

/** Converts date period form values back to the backend raw shape. */
export const applyDatePeriod = (
  current: RawDatePeriod | null | undefined,
  values: DatePeriodValues | null,
): RawDatePeriod | null => {
  if (values === null) return null;
  return {
    __typename: "DatePeriodType",
    ...current,
    periodKind: values.periodKind,
    dateType: values.dateType,
    offsetMonths: values.offsetMonths,
    trailingMonths: values.trailingMonths,
    customRangeKind: values.customRangeKind,
    customStartParameter: values.customStartParameter,
    customStartDate: values.customStartDate,
    customEndParameter: values.customEndParameter,
    customEndDate: values.customEndDate,
  };
};
